export function getHostDirectory() {
  if (location.hostname === "localhost" || location.hostname === "127.0.0.1")
    return "http://localhost:3000/";
  else
    return 'https://sijia-wang.top/';
}